import { AppConfigContext } from '@App/AppConfigContext';
import { Experiments } from '@Config/Experiments';
import { activateExperimentViaFock } from '@Framework/tracking';
import React, { useContext, useState } from 'react';

import { TreatmentNow } from '../../../components/pages';

export const TreatmentNowRoutes = () => {
  const { experiments } = useContext(AppConfigContext);
  const [activatedExperiments, setActivatedExperiments] = useState<Record<string, boolean>>({});

  if (
    !activatedExperiments[Experiments.HIDE_VIDEO_JOURNEY] &&
    experiments[Experiments.HIDE_VIDEO_JOURNEY] !== undefined &&
    experiments[Experiments.HIDE_VIDEO_JOURNEY].active
  ) {
    const activeExperiments = {
      ...activatedExperiments
    };

    activeExperiments[Experiments.HIDE_VIDEO_JOURNEY] = true;
    setActivatedExperiments(activeExperiments);

    activateExperimentViaFock([Experiments.HIDE_VIDEO_JOURNEY]);
  }

  return (
    <>
      <TreatmentNow />
    </>
  );
};
